import { baseBackendUrl } from './baseService';

export interface PrayerRequest {
    id: number;
    userId: string;
    title: string;
    description: string;
    createdDate: string;
    relatedPrayerRequestId?: number;
}

export const prayerRequestService = {
    getAllRequests: async (token: string): Promise<PrayerRequest[]> => {
        const response = await fetch(`${baseBackendUrl}/api/prayer-requests/all`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) throw new Error('Failed to fetch prayer requests');
        return response.json();
    },

    updateRequest: async (request: PrayerRequest, token: string): Promise<void> => {
        const response = await fetch(`${baseBackendUrl}/api/prayer-requests/${request.id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(request)
        });
        if (!response.ok) throw new Error('Failed to update prayer request');
    },

    deleteRequest: async (id: number, token: string): Promise<void> => {
        const response = await fetch(`${baseBackendUrl}/api/prayer-requests/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) throw new Error('Failed to delete prayer request');
    }
};
